import React from "react";
import "react-tech-tree/dist/index.css";
import { ScreenProps } from "../types";
import "./index.css";

function TitleScreen(props: ScreenProps) {
  const clickHandler = () => {
    props.dispatch({
      type: "screen/changeScreen",
      payload: { screen: "#battle" }
    });
  };
  return (
    <div id="title-screen">
      <h1>Adrestia: Sublime Balance</h1>
      <button
        type="button"
        className="bit nes-btn is-primary"
        onClick={clickHandler}
      >
        Endless Mode
      </button>
      <button type="button" className="bit nes-btn is-disabled" disabled>
        Async Multiplayer Mode
      </button>
      <button type="button" className="bit nes-btn is-disabled" disabled>
        Story Mode
      </button>
    </div>
  );
}

export default TitleScreen;
